
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRedoIec as ObiRedoIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-redo-iec.js';
 
 
 

 
 export const ObiRedoIec = createComponent({
   react: React,
   tagName: 'obi-redo-iec',
   elementClass: ObiRedoIecElement,
   events: {
     
   }
  });
 
 